var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"icon",attrs:{"aria-label":_vm.title,"role":"presentation"}},[(_vm.title)?_c('title',{attrs:{"lang":"nl"}},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),_c('g',[_c('use',{attrs:{"xlink:href":'#' + _vm.icon}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }